import React from "react";
import UseGetDashBoardData from "../../../../../Components/Hooks/useDashboardData";
import { ModernStatWidget } from "../../Components/DashboardCard";

function PurchaseOrderToSupplierProcuDash() {
  const { data } = UseGetDashBoardData(`/dashboard/purchaseOrders`);
  const percentage = parseFloat(data?.selected_month_percentage) || 0;
  const isNegative = percentage < 0;

  const POIcon = (
    <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
    </svg>
  );

  return (
    <ModernStatWidget
      title="PO to Suppliers"
      value={data?.total_count || 0}
      percentage={percentage}
      isNegative={isNegative}
      icon={POIcon}
      bgColor="bg-blue-500/10"
      iconColor="text-blue-600"
      badgeLabel="this month"
    />
  );
}

export default PurchaseOrderToSupplierProcuDash;